import nextDynamic from 'next/dynamic';

// The migrated content component reads its :id param via useParams, so this
// wrapper doesn't thread `params` through any more. The original Next.js
// version had `export const dynamic = 'force-dynamic'` (already stripped).
const Content = nextDynamic(() => import('./classic-content'), { ssr: false });

export default function Page() {
  return <Content />;
}
